import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { createTeacherChat, useGetTeacherChat } from "@packages/api/madlenAPI";
import logo from "@packages/assets/logo.png";
import { useAppSelector } from "@packages/store/hooks";

const CreateAssistantView = () => {
  const { type } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [newChatId, setNewChatId] = useState<number | null>(null);

  const selectedModel = useAppSelector(
    (state) =>
      state.user?.teacher?.preferences?.preferredLanguageModel ||
      "claude-4-sonnet",
  );

  const isEmptyAssistantPath =
    location.pathname === "/assistants/new/empty" ||
    location.pathname.startsWith("/assistants/new/empty/");

  useGetTeacherChat(newChatId!, {
    query: {
      enabled: !!newChatId && isEmptyAssistantPath,
      refetchInterval: (data) => {
        if (!data?.state.data?.id) return 1000;

        if (isEmptyAssistantPath) {
          navigate(`/assistants/new/${type}/${newChatId}`);
          return false;
        }

        return false;
      },
    },
  });

  useEffect(() => {
    const initializeChat = async () => {
      try {
        const chat = await createTeacherChat({
          llmModel: selectedModel,
        });
        if (chat.id) setNewChatId(chat.id);
      } catch (error) {
        console.error("Failed to create chat:", error);
      }
    };

    if (isEmptyAssistantPath) {
      initializeChat();
    }
  }, [isEmptyAssistantPath, type, selectedModel]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-primary-500"></div>
      <img
        src={logo}
        alt="logo"
        className="absolute w-8 h-8 animate-bounce mt-2"
      />
    </div>
  );
};

export default CreateAssistantView;
